module.exports = __webpack_public_path__ + "img/background-phone.9050573e.png";